import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=54ae2d04&scoped=true&"
import script from "./RolesList.vue?vue&type=script&lang=js&"
export * from "./RolesList.vue?vue&type=script&lang=js&"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=54ae2d04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae2d04",
  null
  
)

export default component.exports